import { render, staticRenderFns } from "./assessmentReportDetail.vue?vue&type=template&id=c67aec02&scoped=true"
import script from "./assessmentReportDetail.vue?vue&type=script&lang=js"
export * from "./assessmentReportDetail.vue?vue&type=script&lang=js"
import style0 from "./assessmentReportDetail.vue?vue&type=style&index=0&id=c67aec02&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67aec02",
  null
  
)

export default component.exports